import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import DualCTA from './components/DualCTA';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeatureCards from './components/FeatureCards';
import TestimonialGrid from './components/TestimonialGrid';
import SchemaOrg from '@/components/base/SchemaOrg';

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Pandabuy Spreadsheet System",
  "url": "https://pandabuy.sbs/",
  "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa4b8148b8a.jpeg",
  "description": "The ultimate pandabuy spreadsheet system for smarter product sourcing. Curated spreadsheet lists, agent comparison, and optimized sourcing workflow tools.",
  "sameAs": [
    "https://kaspreadsheet.com"
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Pandabuy Spreadsheet System | Ultimate Product Sourcing Guide 2026",
  "description": "Discover the ultimate pandabuy spreadsheet system for smarter product sourcing. Compare shopping agents, access curated spreadsheet lists, and optimize your sourcing workflow with data-driven tools. Updated weekly.",
  "url": "https://pandabuy.sbs/",
  "about": {
    "@type": "Thing",
    "name": "Pandabuy Spreadsheet System",
    "description": "A comprehensive spreadsheet-based product sourcing system that helps shoppers find, compare, and organize products efficiently."
  }
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SchemaOrg data={homeSchema} />
      <SchemaOrg data={webPageSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <DualCTA />
        <CategoryGrid />
        <AboutSection />
        <FeatureCards />
        <TestimonialGrid />
      </main>
      <Footer />
    </div>
  );
}